import { defineSlotRecipe } from '@chakra-ui/react';
import { stepsAnatomy } from '@chakra-ui/react/anatomy';

/** Outlines the current step, where stock's `solid` variant fills it with `colorPalette.muted`. */
export const stepsSlotRecipe = defineSlotRecipe({
  slots: stepsAnatomy.keys(),
  variants: {
    variant: {
      solid: {
        indicator: {
          _current: { bg: 'transparent', color: 'inherit' },
        },
      },
    },
  },
});
